// 用户意见管理
export default [
  {
    path: "/opinion",
    meta: { title: "用户意见管理" },
    component: () => import("../views/opinion/index.vue"),
    children: [
      {
        path: "/opinion/list",
        name: "opinionLlist",
        meta: { title: "用户意见列表", isMenu: true },
        component: () => import("../views/opinion/list.vue"),
      },
    ],
  },
]
